import React, { useState, useEffect } from "react";
import "../CustomCSS/Navigation.css";


export const Navigation = (props) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState("");

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  // Scroll spy logic
  useEffect(() => {
    const handleScroll = () => {
      const sections = document.querySelectorAll("section[id]");
      let currentSection = "";

      sections.forEach((section) => {
        const sectionTop = section.offsetTop - 100; // offset for navbar
        if (window.scrollY >= sectionTop) {
          currentSection = section.getAttribute("id");
        }
      });

      setActiveSection(currentSection);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav className="navbar">
      {/* Toggle on left */}
      <button
        className={`navbar-toggle ${isMenuOpen ? "open" : ""}`}
        onClick={toggleMenu}
        aria-label="Toggle menu"
      >
        <span></span>
        <span></span>
        <span></span>
      </button>

      {/* Logo + Brand */}
      <a href="/" className="navbar-brand">
        {props.data && props.data.smallImage && (
          <img
            src={props.data.smallImage}
            alt="Supatham Ayurvedic Clinic"
            className="navbar-logo"
          />
        )}

        <div className="brand-text-wrapper" aria-hidden="true">
          <div className="brand-main">Supatham</div>
          <div className="brand-sub">Ayurvedic Hospital</div>
        </div>
      </a>

      {/* Nav links with active highlighting */}
      <ul className={`navbar-nav ${isMenuOpen ? "open" : ""}`}>
        <li>
          <a href="/#services" className={activeSection === "services" ? "active" : ""}>
            Services
          </a>
        </li>
        <li>
          <a href="/#specialities" className={activeSection === "specialities" ? "active" : ""}>
            Specialities
          </a>
        </li>
        <li>
          <a href="/#features" className={activeSection === "features" ? "active" : ""}>
            Features
          </a>
        </li>
        <li>
          <a href="/#whyus" className={activeSection === "whyus" ? "active" : ""}>
            Why Us
          </a>
        </li>
        <li>
          <a href="/#expertise" className={activeSection === "expertise" ? "active" : ""}>
            Expertise
          </a>
        </li>
        <li>
          <a href="/#aboutus" className={activeSection === "aboutus" ? "active" : ""}>
            About Us
          </a>
        </li>
        <li>
          <a href="/#ayurvedham" className={activeSection === "ayurvedham" ? "active" : ""}>
            About Ayurvedham
          </a>
        </li>
        <li>
          <a href="/#contactus" className={activeSection === "contactus" ? "active" : ""}>
            Contact Us
          </a>
        </li>
      </ul>
    </nav>
  );
};
